import React from "react";
import Header from "../components/Header";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function ErrorPage() {
  return (
    <main>
      <Header />
      <section className="newsletter section">
        <div className="container-sm">
          <div className="newsletter-inner section-inner">
            <div>
              <div className="container">
                <h2>Whoops! This page got lost in conversation</h2>
                <p>
                  Don't worry, you can continue to -
                  <ul>
                    <li>
                      <a href="/">Home Page </a>
                    </li>
                    <li>
                      <a href="/articles">Articles </a>
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Contact />
      <Footer />
    </main>
  );
}
